export const comportementalData = [
  {
    title: "Bilan comportemental - Chiens",
    subtitle: "140€ (frais kilométriques non inclus)",
    image: "tsuna.jpeg",
    description: "Scéance d'1h30 à 2h"
  },
  {
    title: "Bilan comportemental - Chats",
    subtitle: "140€ (frais kilométriques non inclus)",
    image: "chat.png",
    description: "Scéance d'1h30 à 2h"
  },
];